// Automate List "Add"/"Removals" review-tile visibility.
// Each tile is shown iff its own dropdown is set to "I'll do it myself" (MANUAL) —
// the two settings are independent, so New Properties and Property Changes never affect
// each other's tile.
const MANUAL = 'MANUAL';

const getAutomateListVisibility = (addAction, removeAction) => ({
  showAdd: addAction === MANUAL,
  showRemovals: removeAction === MANUAL,
});

export default getAutomateListVisibility;
